/* Cloud Seven PJs: holiday-first, randomized, progressively loaded 405-product feed.
 Shopify collection pagination stays authoritative; no Storefront API keys required. */
(() => {
  const randomize = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  async function boot(root = document) {
    const nodes = Array.from(root.querySelectorAll('[data-cs-feed]')).sort((a,b) => Number(a.dataset.csPhase) - Number(b.dataset.csPhase));
    if (!nodes.length || nodes[0].dataset.csReady === 'true') return;
    for(const n of nodes) n.dataset.csReady = 'true';
    const seen = new Set();
    let active = 0;
    let observer = null;
    const phases = nodes.map(node => {
      const grid = node.querySelector('[data-cs-grid]');
      const foot = node.querySelector('[data-cs-more]');
      const max = Math.max(1,Number(foot?.dataset.csPages) || 1);
      const queue = randomize(Array.from({length:max},(_,i)=>i+1));
      return {node,grid,foot,queue,initial:Array.from(grid?.children||[]),loading:false,started:false,shown:0};
    });
    function addCards(phase, cardNodes) {
      if(!phase.grid) return 0;
      const cards = randomize(Array.from(cardNodes));
      const frag = document.createDocumentFragment();
      let added = 0;
      for(const card of cards) {
        const id = card.getAttribute('data-cs-product');
        if(!id || seen.has(id)) continue;
        seen.add(id);
        frag.appendChild(card);
        added++;
      }
      phase.grid.appendChild(frag);
      phase.shown += added;
      const label = phase.foot?.querySelector('[data-cs-count]');
      if(label) label.textContent = phase.shown + ' products revealed';
      return added;
    }
    async function requestPage(phase,page) {
      const url = new URL(location.href);
      url.searchParams.set('page',String(page));
      url.searchParams.set('section_id',phase.node.dataset.csSection);
      const resp = await fetch(url.toString(),{credentials:'same-origin'});
      if(!resp.ok) throw new Error('Shopify collection page '+page+' unavailable');
      const html = new DOMParser().parseFromString(await resp.text(),'text/html');
      const grid = html.querySelector('[data-cs-grid]');
      if(!grid) throw new Error('Shopify section response missing product grid');
      return Array.from(grid.children);
    }
    function moreVisible(phase) {
      if(!phase.foot) return false;
      const r=phase.foot.getBoundingClientRect();
      return r.top < innerHeight + 360 && r.bottom >= -200;
    }
    async function nextPage() {
      const phase = phases[active];
      if(!phase || phase.loading) return;
      if(!phase.queue.length) { finishPhase(); return; }
      phase.loading = true;
      const page = phase.queue.shift();
      const link = phase.foot?.querySelector('[data-cs-more-link]');
      if(link){link.textContent='Loading more pajamas…';link.setAttribute('aria-busy','true');}
      try {
        let cards = page===1 ? phase.initial : await requestPage(phase,page);
        addCards(phase,cards);
        if(link){link.textContent='Load more pajamas ↓';link.removeAttribute('aria-busy');}
      } catch(error) {
        phase.queue.unshift(page);
        if(link){link.textContent='Retry loading pajamas';link.removeAttribute('aria-busy');}
        console.warn('Cloud Seven lazy catalog:',error);
        phase.loading=false;
        return;
      }
      phase.loading = false;
      if(!phase.queue.length) { finishPhase(); return; }
      if(moreVisible(phase)) requestAnimationFrame(nextPage);
    }
    function observe(phase) {
      if(observer)observer.disconnect();
      observer = null;
      if(!('IntersectionObserver' in window)||!phase.foot)return;
      observer = new IntersectionObserver(entries => {
        if(entries.some(e=>e.isIntersecting)) nextPage();
      },{rootMargin:'420px 0px'});
      observer.observe(phase.foot);
    }
    function finishPhase() {
      if(observer) observer.disconnect();
      const phase = phases[active];
      if(!phase)return;
      const label=phase.foot?.querySelector('[data-cs-count]');
      if(label) label.textContent = phase.shown +' unique products shown';
      const link=phase.foot?.querySelector('[data-cs-more-link]');
      if(link){link.textContent='View collection →';}
      active++;
      if(active<phases.length) {
        const following=phases[active];
        following.node.style.display='block';
        launchPhase(following);
      }
    }
    function launchPhase(phase) {
      if(phase.started)return;
      phase.started=true;
      if(phase.grid)phase.grid.replaceChildren();
      phase.node.style.display='block';
      observe(phase);
      // Start with a randomly chosen Shopify page, not the same first 24 products on every visit.
      nextPage();
    }
    nodes.forEach(node => {
      node.addEventListener('click', event=>{
        const link = event.target.closest('[data-cs-more-link]');
        if(!link) return;
        const phase=phases[active];
        if(!phase || node!==phase.node || !phase.queue.length) return;
        event.preventDefault();
        nextPage();
      });
    });
    launchPhase(phases[0]);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});
  else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();